<template>
  <a-entity @loaded="ready">
    <a-entity
      look-at=".Camera"
      class="Raycaster__silhouette"
      cursor="fuseTimeout: 2000; fuse: true"
      raycaster="objects: .Fuse"
      @fusing="fusing"
      @mouseleave="fusingCancel"
      @click="click"
    />
    <a-entity
      look-at=".Camera"
      @click="click"
      cursor="fuse: false; rayOrigin: mouse"
      raycaster="objects: .Fuse"
    />
  </a-entity>
</template>

<script>
export default {
  name: 'ProgressCircle',
  methods: {
    fusing(e) {
      this.$tl.play().timeScale(1)
    },
    fusingCancel() {
      this.$tl.reverse().timeScale(3)
    },
    click() {
      this.fusingCancel()
    },
    ready() {
      const tween = { progress: 0 }
      this.$progress = new THREE.Mesh(
        new THREE.RingBufferGeometry(0, 0, 0, null, 0, 0),
        new THREE.MeshBasicMaterial({color: 0xffffff, flatShading: true, depthTest: false, transparent: true })
      )

      this.$el.object3D.add(this.$progress)

      this.$tl = new TimelineMax({ paused: true })
        .set(this.$progress.material, { opacity: 1 })
        .to(tween, 2, {
          progress: Math.PI * 2,
          onUpdate: () => {
            this.$progress.geometry.dispose()
            this.$progress.geometry = new THREE.RingBufferGeometry(.24, .26, 24, null, 0, tween.progress)
          },
          ease: Linear.easeInOut })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/cursor/ProgressCircle.vue